const GET_STATISTICS_ING = 'STATISTICS/GET_STATISTICS_ING'
const GET_STATISTICS_SUCCESS = 'STATISTICS/GET_STATISTICS_SUCCESS'
const GET_STATISTICS_FAILURE = 'STATISTICS/GET_STATISTICS_FAILURE'
const GET_DASHBOARD_RECORDS_ING = 'STATISTICS/GET_DASHBOARD_RECORDS_ING'
const GET_DASHBOARD_RECORDS_SUCCESS = 'STATISTICS/GET_DASHBOARD_RECORDS_SUCCESS'
const GET_DASHBOARD_RECORDS_FAILURE = 'STATISTICS/GET_DASHBOARD_RECORDS_FAILURE'

const defaultState = {
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_STATISTICS_SUCCESS:
      return {
        ...state,
        statistics: action.payload
      }
    case GET_STATISTICS_FAILURE:
      return {
        ...state,
        statistics: null
      }
    case GET_DASHBOARD_RECORDS_SUCCESS:
      return {
        ...state,
        dashboardRecords: action.payload
      }
    case GET_DASHBOARD_RECORDS_FAILURE:
      return {
        ...state,
        dashboardRecords: null
      }
    default:
      return {...state}
  }
}

export const getStatistics = () => {
  return {
    types: [GET_STATISTICS_ING, GET_STATISTICS_SUCCESS, GET_STATISTICS_FAILURE],
    promise: (apiClient) => apiClient.get('/api/statistics')
  }
}

export const getDashboardRecords = () => {
  return {
    types: [GET_DASHBOARD_RECORDS_ING, GET_DASHBOARD_RECORDS_SUCCESS, GET_DASHBOARD_RECORDS_FAILURE],
    promise: (apiClient) => apiClient.get('/api/statistics/dashboard')
  }
}
